var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3085_155617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00045 4.05558C8.9823 4.05558 9.77824 3.25964 9.77824 2.27779C9.77824 1.29594 8.9823 0.5 8.00045 0.5C7.0186 0.5 6.22266 1.29594 6.22266 2.27779C6.22266 3.25964 7.0186 4.05558 8.00045 4.05558Z",
    fill: "#9FA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00045 10.2782C8.9823 10.2782 9.77824 9.4823 9.77824 8.50045C9.77824 7.5186 8.9823 6.72266 8.00045 6.72266C7.0186 6.72266 6.22266 7.5186 6.22266 8.50045C6.22266 9.4823 7.0186 10.2782 8.00045 10.2782Z",
    fill: "#9FA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00045 16.5009C8.9823 16.5009 9.77824 15.705 9.77824 14.7231C9.77824 13.7413 8.9823 12.9453 8.00045 12.9453C7.0186 12.9453 6.22266 13.7413 6.22266 14.7231C6.22266 15.705 7.0186 16.5009 8.00045 16.5009Z",
    fill: "#9FA4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3085_155617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalThreeDots);
export default __webpack_public_path__ + "static/media/VerticalThreeDots.6c8615bfc404ad6ccbf99b675c6b4311.svg";
export { ForwardRef as ReactComponent };